/* eslint-disable eqeqeq */
import React, { useState, useCallback, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import BootstrapTable from "react-bootstrap-table-next";
import {
  API,
  defaultLimitPagination,
  get,
  ProjectStatus,
} from "../../../config";
import Spin from "../../common/Spin";
import Pagination from "../../common/Pagination";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faEye } from "@fortawesome/free-solid-svg-icons";
import ImportLogDetail from "./ImportLogDetail";
// import NotImportedDelete from "./NotImportedDelete";
import { debounce } from "underscore";
import NotImportedLogEdit from "./NotImportedLogEdit";
import moment from "moment";
import { formatName, formatNumber } from "../../common/Misc";
import SearchBox from "../../common/SearchBox";

const NotImportedLogs = ({ builderId }) => {
  var today = new Date();
  const navigate = useNavigate();
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const defaultPage = query.get("page");
  const defaultLimit = query.get("limit");
  const [notImportLogs, setNotImportLogs] = useState({});
  const [loading, setLoading] = useState(false);
  const [notImportLogId, setNotImportLogId] = useState();
  const [importLogModal, setImportLogModal] = useState(false);
  const search = query.get("search");
  const [searchParam, setSearchParam] = useState(search || "");
  const [searchParamData, setSearchParamData] = useState(search || "");

  const [page, setPage] = useState(defaultPage || 1);
  const [limit, setLimit] = useState(defaultLimit || defaultLimitPagination);
  const [total, setTotal] = useState();
  const [from, setFrom] = useState();
  const [to, setTo] = useState();
  const [editModal, setEditModal] = useState(false);

  const [sortField, setSortField] = useState();
  const [sortOrder, setSortOrder] = useState();

  const toggleEdit = (id) => {
    if (!editModal) {
      setNotImportLogId(id);
    } else {
      setNotImportLogId();
    }
    setEditModal(!editModal);
  };

  const toggleShowModal = () => {
    setImportLogModal(!importLogModal);
  };

  const handleDetails = (id) => {
    setNotImportLogId(id);
    setImportLogModal(true);
  };

  // *API Call for Import Logs List - Start
  const fetchNotImportedLogs = useCallback(
    async (passLimit, passPage) => {
      try {
        setLoading(true);
        const { data } = await get(
          `${API.PROJECT_IMPORT_LOGS}?limit=${
            passLimit ? passLimit : limit ? limit : defaultLimitPagination
          }&page=${passPage ? passPage : page ? page : 1}&status=0&search=${
            searchParam ? searchParam : ""
          }&sort_column=${sortField ? sortField : ""}&sort_order=${
            sortOrder ? sortOrder : ""
          }${builderId ? "&builder_id=" + builderId : ""}`
        );
        setLimit(data?.data?.per_page);
        setPage(data?.data?.current_page);
        setFrom(data?.data?.from);
        setTo(data?.data?.to);
        setTotal(data?.data?.total);
        setNotImportLogs(data?.data?.data);
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [builderId, searchParam, sortField, sortOrder]
  );

  useEffect(() => {
    fetchNotImportedLogs();
  }, [fetchNotImportedLogs]);
  // *API Call for Import Logs List - End

  useEffect(() => {
    navigate(
      `/project-import-logs?tab=not-imported&limit=${
        limit ? limit : defaultLimitPagination
      }&page=${page ? page : 1}&search=${
        searchParam ? searchParam : ""
      }&builder_id=${builderId ? builderId : ""}`,
      { replace: true }
    );
  }, [navigate, page, limit, searchParam, builderId]);

  // const handleDelete = () => {
  //   fetchNotImportedLogs();
  // };

  const getVerifiedDateTime = (date) => {
    return moment(date).format("DD-MM-YYYY HH:mm:ss").toString();
  };

  const handleTableChange = (type, { page, sortField, sortOrder }) => {
    if (type === "sort") {
      setPage(1);
      setSortField(sortField);
      setSortOrder(
        sortOrder === "asc" ? "ASC" : sortOrder === "desc" && "DESC"
      );
    }
  };

  // *Import Logs List Table Row and Column Generation, Filtering and Sorting of Record, Select Row and Expand Row - Start
  const notImportLogsGenerator = (quantity) => {
    const items = [];
    for (let i = 0; i < quantity; i++) {
      items.push({
        builder_id: notImportLogs[i]?.builder_id,
        key: notImportLogs[i]?.id,
        project_id: notImportLogs[i]?.id,
        project_name:
          notImportLogs[i]?.subscription?.status === 0 ||
          notImportLogs[i]?.subscription?.status === 1 ? (
            <Link
              to={{
                pathname: `/projects/${notImportLogs[i]?.id}`,
              }}
              className="project-name-link active"
            >
              {notImportLogs[i]?.project_name}
            </Link>
          ) : (
            notImportLogs[i]?.project_name
          ),
        // email: notImportLogs[i]?.email ? notImportLogs[i]?.email : "-",
        // phone: notImportLogs[i]?.phone
        //   ? formatPhone(notImportLogs[i]?.phone)
        //   : "-",
        end_date: notImportLogs[i]?.end_date ? notImportLogs[i]?.end_date : "-",
        // address: formatedAddress(
        //   notImportLogs[i]?.street,
        //   notImportLogs[i]?.suburb?.name,
        //   notImportLogs[i]?.state?.short_name,
        //   notImportLogs[i]?.postal_code
        // ),
        status: notImportLogs[i]?.project_status
          ? notImportLogs[i]?.project_status == 2 &&
            notImportLogs[i]?.end_date &&
            new Date(
              notImportLogs[i]?.end_date?.split("-")?.reverse()?.join("-")
            ) < today
            ? "Delayed"
            : ProjectStatus?.find(
                (item) =>
                  item?.value === Number(notImportLogs[i]?.project_status)
              )?.label
          : "-",
        estimated_cost: notImportLogs[i]?.estimated_cost
          ? `$${formatNumber(Number(notImportLogs[i]?.estimated_cost))}`
          : "-",
        imported_by: notImportLogs[i]?.imported_by
          ? formatName(
              notImportLogs[i]?.imported_by?.first_name,
              notImportLogs[i]?.imported_by?.last_name
            )
          : "-",
        import_from: notImportLogs[i]?.import_from
          ? notImportLogs[i]?.import_from
          : "BuildTrust",
        project_last_sync_date: notImportLogs[i]?.project_last_sync_date
          ? getVerifiedDateTime(notImportLogs[i]?.project_last_sync_date)
          : "-",
        message: notImportLogs[i]?.message
          ? notImportLogs[i]?.message
          : "Please enter required fields.",
        import_date: (
          <span>
            {notImportLogs[i]?.updated_at
              ? moment(
                  notImportLogs[i]?.updated_at,
                  "DD-MM-YYYY HH:mm:SS"
                ).format("DD-MM-YYYY")
              : notImportLogs[i]?.created_at
              ? moment(
                  notImportLogs[i]?.created_at,
                  "DD-MM-YYYY HH:mm:SS"
                ).format("DD-MM-YYYY")
              : ""}
          </span>
        ),
        action: (
          <>
            <FontAwesomeIcon
              icon={faEye}
              size="1x"
              onClick={() => handleDetails(notImportLogs[i]?.id)}
            />
            <>
              <span></span>&nbsp;&nbsp;/&nbsp;&nbsp;
              <FontAwesomeIcon
                icon={faEdit}
                size="1x"
                onClick={() => toggleEdit(notImportLogs[i]?.id)}
              />
            </>

            {/* <>
            <span></span>&nbsp;&nbsp;/&nbsp;&nbsp;
              <Link
                to={{
                  pathname: `/projects/${projectId}/chart-of-account-import-logs/edit`,
                  search: `?id=${notImportLogs[i]?.id}`,
                }}
              >
                <FontAwesomeIcon icon={faEdit} size="1x" />
              </Link>
            </> */}
            {/* <NotImportedDelete
              handleDelete={handleDelete}
              id={notImportLogs[i]?.id}
            /> */}
          </>
        ),
      });
    }
    return items;
  };

  const notImportLogsData = notImportLogsGenerator(notImportLogs?.length);

  const columns = [
    {
      dataField: "import_date",
      text: "Import Date",
      style: { width: "10%" },
    },
    {
      dataField: "project_name",
      text: "Project Name",
      sort: true,
    },
    // {
    //   dataField: "email",
    //   text: "Email",
    //   sort: true,
    // },
    // {
    //   dataField: "phone",
    //   text: "Phone No.",
    //   sort: true,
    // },
    // {
    //   dataField: "address",
    //   text: "Project Address",
    //   // sort: true,
    // },
    {
      dataField: "end_date",
      text: "End Date",
      // sort: true,
    },
    {
      dataField: "estimated_cost",
      text: "Estimated Cost",
    },
    {
      dataField: "status",
      text: "Project Status",
    },
    // {
    //   dataField: "subscribe",
    //   text: "Manage",
    //   align: "center",
    //   headerAlign: "center",
    //   style: { width: "127px" },
    // },
    {
      dataField: "imported_by",
      text: "Imported By",
      sort: true,
    },
    {
      dataField: "import_from",
      text: "Import From",
    },
    {
      dataField: "project_last_sync_date",
      text: "Last synchronised time",
    },
    {
      dataField: "message",
      text: "Message",
    },
    {
      dataField: "action",
      text: "Action",
      align: "center",
      headerAlign: "center",
      style: { width: "97px" },
    },
  ];

  const handleUpdateLimit = (e) => {
    const limit = e.target.value;
    setLimit(limit);
    setPage(1);
    fetchNotImportedLogs(limit, 1);
  };

  const handleChangePage = (page) => {
    setPage(page);
    fetchNotImportedLogs(limit, page);
  };

  // *Import Logs List Table Row and Column Generation, Filtering and Sorting of Record, Select Row and Expand Row - End

  const handleSearchChange = (event) => {
    const { value: nextValue } = event.target;
    setSearchParamData(nextValue);
    setPage(1);
    debouncedSave(nextValue);
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debouncedSave = useCallback(
    debounce((nextValue) => {
      setSearchParam(nextValue);
      setPage(1);
    }, 300),
    []
  );

  const handleClearSearch = () => {
    setSearchParamData();
    setSearchParam("");
  };

  return (
    <>
      <div className="table-top-btn">
        <SearchBox
          placeholder={"Search Not Imported Logs"}
          searchParamData={searchParamData}
          handleSearchChange={handleSearchChange}
          handleClearSearch={handleClearSearch}
        />
      </div>
      <div className="audit-statement">
        {loading && <Spin />}
        <BootstrapTable
          keyField="batch_id"
          remote
          data={notImportLogsData}
          columns={columns}
          noDataIndication="No Data Found"
          onTableChange={handleTableChange}
        />

        <Pagination
          total={total}
          limit={parseInt(limit)}
          currentPage={page}
          updateLimit={handleUpdateLimit}
          updatePage={handleChangePage}
          from={from}
          to={to}
        />
      </div>

      {importLogModal && (
        <ImportLogDetail
          toggleShowModal={toggleShowModal}
          importLogId={notImportLogId}
          importLogModal={importLogModal}
          builderId={builderId}
        />
      )}

      {editModal && (
        <NotImportedLogEdit
          logId={notImportLogId}
          toggleEditModal={toggleEdit}
          fetchNotImportedLogs={() => fetchNotImportedLogs(limit, page)}
          editModal={editModal}
          builderId={builderId}
        />
      )}
    </>
  );
};

export default NotImportedLogs;
